module.exports = __webpack_public_path__ + "static/media/colicoli26.0a505f9f.webp";